// Captures where a visitor came from so signups can be attributed to a channel.
// Priority: explicit ?ref= / ?utm_source= param > referrer heuristic > "direct".
// The first-touch source is persisted so it survives navigation before signup.

const KEY = "aftbrn_source";

const fromReferrer = (ref) => {
  if (!ref) return null;
  const r = ref.toLowerCase();
  if (r.includes("x.com") || r.includes("twitter.com") || r.includes("t.co")) return "x";
  if (r.includes("t.me") || r.includes("telegram")) return "telegram";
  if (r.includes("discord")) return "discord";
  if (r.includes("reddit")) return "reddit";
  if (r.includes("google.")) return "google";
  return "referral";
};

export const captureSource = () => {
  if (typeof window === "undefined") return "direct";
  const existing = localStorage.getItem(KEY);
  if (existing) return existing;

  const params = new URLSearchParams(window.location.search);
  const explicit = params.get("ref") || params.get("utm_source") || params.get("source");
  const ref = document.referrer || "";
  const source = (explicit || fromReferrer(ref) || "direct").toLowerCase().slice(0, 40);

  localStorage.setItem(KEY, source);
  return source;
};

export const getSource = () => {
  if (typeof window === "undefined") return "direct";
  return localStorage.getItem(KEY) || captureSource();
};
